import { baseColors, dimensions } from "@Constants/baseStyles"
import React from "react"
import { Dimensions, Image, View } from "react-native"
import { ActivityIndicator } from "react-native-paper"
import splash_soignant from "@assets/splash_soignant.png"
import splash_cpts from "@assets/splash_cpts.png"
import { Spacer } from "@Components/Space"
import Constants from "expo-constants"

const { height } = Dimensions.get("screen")
const { platform } = Constants.expoConfig.extra
const isCpts = platform === "cpts"

const MainLoading = () => {
    const splashImg = !isCpts ? splash_soignant : splash_cpts

    return (
        <View
            style={{
                flex: 1,
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: baseColors.green.primary
            }}
        >
            <Spacer height={48} />

            <Image
                style={{
                    height: height,
                    width: dimensions.fullWidth
                }}
                resizeMode="cover"
                source={splashImg}
                defaultSource={splashImg}
            />
            <View
                style={{
                    position: "absolute",
                    justifyContent: "center",
                    alignItems: "center",
                    top: "82%"
                }}
            >
                <ActivityIndicator animating color={"white"} size={40} />
            </View>
        </View>
    )
}

export default MainLoading
